import React, { useRef, useEffect } from "react";
import { ModalContainer, ModalWrap, ModalContent } from "./styled";

const Modal = ({ children, onClose }) => {
  const insideRef = useRef();

  const checkClickOutside = (e) => {
    if (insideRef.current && !insideRef.current.contains(e.target)) {
      onClose();
    }
  };

  useEffect(() => {
    setTimeout(() => window.addEventListener("click", checkClickOutside), 100);
    return () => {
      window.removeEventListener("click", checkClickOutside);
    };
  }, []);

  return (
    <ModalContainer>
      <ModalWrap>
        <ModalContent ref={insideRef}>{children}</ModalContent>
      </ModalWrap>
    </ModalContainer>
  );
};

export default Modal;
